import { footerlogo } from "../../assets/images/images";
import "./footer.css";
import React from "react";
import { useTranslation } from 'react-i18next'; // Import useTranslation

export default function Footer() {
  const { t } = useTranslation(); // Use the useTranslation hook

  return (
    <div className="Footer">
      <div className="list var1">
        <p className="title">{t('footer.agencyTitle')}</p> {/* Translated text */}
        <p className="el">{t('footer.aboutUs')}</p> {/* Translated text */}
        <p className="el">{t('footer.contact')}</p> {/* Translated text */}
        <p className="el">{t('footer.mob')}</p> {/* Translated text */}
        <p className="el">{t('footer.tel')}</p> {/* Translated text */}
        <p className="el">{t('footer.email')}</p> {/* Translated text */}
      </div>
      <div className="list var3">
        <img src={footerlogo} alt="logo" loading="lazy" />
        <p className="sub_el">{t('footer.credits')}</p> {/* Translated text */}
        <p className="sub_el">
          {t('footer.privacyPolicy')} - {t('footer.termsAndConditions')} {/* Translated text */}
        </p>
      </div>
      <div className="list var2">
        <p className="title">{t('footer.servicesTitle')}</p> {/* Translated text */}
        <p className="el">{t('footer.organizedTrips')}</p> {/* Translated text */}
        <p className="el">{t('footer.circuitsAndExcursions')}</p> {/* Translated text */}
        <p className="el">{t('footer.eventPlanning')}</p> {/* Translated text */}
        <p className="el">{t('footer.visaAndReservation')}</p> {/* Translated text */}
      </div>
    </div>
  );
}